var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLaptop)?_c('div',[(_vm.AllowedMobAndLap)?_c('MobileStudentLogin'):_c('Block')],1):_c('LaptopStudentLogin')],1)}
var staticRenderFns = []

export { render, staticRenderFns }